import { ajaxCatch, AjaxCatchExtraActions } from 'rxOperators/ajaxCatch'
import { filterRequest } from 'rxOperators/filterRequestOfType'
import { EpicRefined } from 'interfaces/middleware'
import { of, merge, EMPTY } from 'rxjs'
import { mergeMap, map } from 'rxjs/operators'
import {
  CCOnboardingActions,
  CreateCCPaymentMethodAction,
  DeleteCCPaymentMethodAction,
  GetCCPaymentMethodsAction,
  SetCCPaymentMethodsAction,
} from 'components/features/creditCard/creditCardStore/actions'
import { CC_PAYMENT_METHODS_CREATE_URL, CC_PAYMENT_METHODS_DELETE_URL, CC_PAYMENT_METHODS_URL } from 'components/features/creditCard/creditCardStore/endpoints'
import FloatingPaneAction, { ModifyFloatingPaneAction } from 'actions/floatingPanesActions'
import { CreditCardFloatingPane, CREDIT_CARD_PANE } from 'components/features/creditCard/creditCardStore/floatingPane'
import { normalize } from 'helpers/normalizeHelpers'
import { WsActions, WsMessageAction } from 'actions/webSocketActions'
import { byType } from 'rxOperators/byType'

export const getCCPaymentMethodsEpic: EpicRefined<CCOnboardingActions | AjaxCatchExtraActions> = (action$, _store, { get }) => action$.pipe(
  filterRequest(GetCCPaymentMethodsAction.type),
  mergeMap((action) => get(CC_PAYMENT_METHODS_URL).pipe(
    map(({ response }) => {
      const { items } = response

      return action.success(
        normalize(items, 'uid')
      )
    }),
    ajaxCatch((error) => of(action.fail({ errorCode: error.status }))),
  )),
)

export const setCCPaymentMethodsEpic: EpicRefined<WsActions | SetCCPaymentMethodsAction> = (action$) =>
  action$.pipe(
    byType(WsMessageAction.type),
    mergeMap(({ payload }) => {
      if (payload.event === 'payment_methods_changed') {
        if (!payload.data?.payment_methods) {
          return EMPTY
        }
        const paymentMethods = normalize(payload.data.payment_methods.items, 'uid')
        return of(new SetCCPaymentMethodsAction(paymentMethods))
      }

      return EMPTY
    })
  )


export const deleteCCPaymentMethodEpic: EpicRefined<CCOnboardingActions | AjaxCatchExtraActions | FloatingPaneAction> = (action$, _, { post }) => action$.pipe(
  filterRequest(DeleteCCPaymentMethodAction.type),
  mergeMap((action) => {
    return post({ url: CC_PAYMENT_METHODS_DELETE_URL, params: { uid: action.payload.params }}, {}).pipe(
      mergeMap(({ response }) => {
        return merge(
          of(new ModifyFloatingPaneAction({
            type: CREDIT_CARD_PANE,
            mode: 'paymentMethods',
          })),
          of(action.success(response)),
          of(new GetCCPaymentMethodsAction())
        )
      }),
      ajaxCatch((error) => of(action.fail({ errorCode: error.status, errorsMap: error.response })))
    )
  }),
)

export const createPaymentMethodEpic: EpicRefined<CCOnboardingActions | AjaxCatchExtraActions | FloatingPaneAction> = (action$, _, { post }) => action$.pipe(
  filterRequest(CreateCCPaymentMethodAction.type),
  mergeMap((action: CreateCCPaymentMethodAction) => {
    return post(CC_PAYMENT_METHODS_CREATE_URL, { body: action.payload.params.paymentMethod }).pipe(
      mergeMap(({ response }) => {
        const { payload: { params: { paymentMode }}} = action

        const resultingPane: CreditCardFloatingPane = !!paymentMode ? {
          type: CREDIT_CARD_PANE,
          mode: paymentMode,
          step: 'paymentMethod',
        } : {
          type: CREDIT_CARD_PANE,
          mode: 'paymentMethods',
          backButton: null,
        }

        return merge(
          of(new ModifyFloatingPaneAction(resultingPane as CreditCardFloatingPane)),
          of(action.success(response)),
          of(new GetCCPaymentMethodsAction())
        )
      }),
      ajaxCatch((error) => of(action.fail({ errorCode: error.status, errorsMap: error.response })))
    )
  }),
)
